import CityPageTemplate from "../city-template/CityPageTemplate";
import { yanktonConfig } from "./data";

export default function YanktonPage() {
  return <CityPageTemplate config={yanktonConfig} />;
}